export default "__VITE_PUBLIC_ASSET__00d749b6__"